import {
	faChevronLeft,
	faChevronRight,
} from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React, { useEffect, useRef, useState } from 'react';
import { fetchNews } from '../../ApiController/newsApi';
import defaultImage from '../../img/default.png';
import './News.css';
import NewsItemModal from './NewsItemModel';

const NewsFeed = () => {
	const scrollContainer = useRef(null);
	const [newsItems, setNewsItems] = useState([]);
	const [modalContent, setModalContent] = useState(null);

	useEffect(() => {
		const loadNews = async () => {
			try {
				const newsData = await fetchNews();
				setNewsItems(newsData);
			} catch (error) {
				console.error('Failed to load news:', error);
			}
		};
		loadNews();

		// Ställ in ett intervall för att upprepa datahämtningen var femte minut
		const interval = setInterval(loadNews, 60000); // 60000 ms = 1 minuter

		// Uppröjningsfunktion för att rensa intervallet
		return () => clearInterval(interval);
	}, []);

	const smoothScroll = (scrollOffset) => {
		const start = scrollContainer.current.scrollLeft;
		const end = start + scrollOffset;
		const duration = 750;
		let startTime = null;

		function step(timestamp) {
			if (!startTime) startTime = timestamp;
			const progress = timestamp - startTime;
			const position = easeInOutQuad(progress, start, end - start, duration);
			scrollContainer.current.scrollLeft = position;
			if (progress < duration) {
				window.requestAnimationFrame(step);
			}
		}

		window.requestAnimationFrame(step);
	};

	function easeInOutQuad(t, b, c, d) {
		t /= d / 2;
		if (t < 1) return (c / 2) * t * t + b;
		t--;
		return (-c / 2) * (t * (t - 2) - 1) + b;
	}

	const handleClick = (item) => {
		setModalContent({
			content: item.comment,
			author: `${item.Employee.dataValues.firstName} ${item.Employee.dataValues.lastName}`,
			timestamp: item.timestamp,
		});
	};

	const handleClose = () => {
		setModalContent(null);
	};
	const handleError = (e) => {
		e.target.src = defaultImage;
	};

	return (
		<div className="news-feed-wrapper">
			<button onClick={() => smoothScroll(-300)} className="scroll-button left">
				<FontAwesomeIcon icon={faChevronLeft} />
			</button>
			<div className="news-feed-container" ref={scrollContainer}>
				{newsItems.map((item, index) => (
					<div
						key={index}
						className="news-item"
						onClick={() => handleClick(item)}
					>
						<p>
							{item.comment ? item.comment.substring(0, 100) : 'No comment'}...
						</p>
						<img
							src={item.Employee.imgdata || defaultImage}
							alt={`${item.Employee.firstName} ${item.Employee.lastName}`}
							onError={handleError}
							className="news-item-image"
						/>
					</div>
				))}
			</div>
			<button onClick={() => smoothScroll(300)} className="scroll-button right">
				<FontAwesomeIcon icon={faChevronRight} />
			</button>
			{modalContent && (
				<NewsItemModal
					title={modalContent.title}
					content={modalContent.content}
					author={modalContent.author}
					timestamp={modalContent.timestamp}
					onClose={handleClose}
				/>
			)}
		</div>
	);
};

export default NewsFeed;
